export default "__VITE_ASSET__2glXJHMd__"